



































import { Vue, Component, Prop } from "vue-property-decorator";
import * as user from "../_store/user.module";
import { bus } from "../main";
import * as data from "../_store/data.module";
import CreateDialog from "../components/Dialogs/CreateDialog.vue";
import DetailsDialog from "../components/Dialogs/DetailsDialog.vue";
import EditDialog from "../components/Edit/EditDialog.vue";

@Component({
	components: {
		CreateDialog,
		DetailsDialog,
		EditDialog
	}
})
export default class RubricaAziende extends Vue {
	@Prop() idAzienda!: any;
	@Prop() nomeAzienda!: any;
	@Prop() params!: any;

	private listaContatti: any;
	private search: string;
	private loadingData: boolean;
	private createDialogParams: any;
	private idIstituto: number;

	constructor() {
		super();
		this.idIstituto = 0;
		this.search = "";
		this.listaContatti = [];
		this.loadingData = true;
		this.createDialogParams = {
			visible: true,
			type: "contattoAzienda"
		};
	}

	loadContattiAzienda() {
		var instituteInfo = user.readInstituteInfo(this["$store"]);
		var payload = {
			idAzienda: this.idAzienda,
			idIstituto: instituteInfo.id
		};
		data
			.dispatchContattiAzienda(this["$store"], payload)
			.then(result => {
				this.listaContatti = result;
				this.loadingData = false;
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	deleteContatto(idContatto: number) {
		var instituteInfo = user.readInstituteInfo(this["$store"]);
		var payload = {
			idContatto: idContatto,
			idIstituto: instituteInfo.id
		};
		if (confirm("Eliminare il contatto selezionato?")) {
			user.dispatchDeleteContattoAzienda(this["$store"], payload)
			.then(() => {
				bus.$emit("successfullOperation", "Contatto eliminato con successo");
				this.loadContattiAzienda();
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
		}
	}

	created() {
		var instituteInfo = user.readInstituteInfo(this["$store"]);
		this.idIstituto = instituteInfo.id;
		this.loadContattiAzienda();

		bus.$on("loadContattiAzienda", () => {
			this.loadContattiAzienda();
		});
	}
}
